import { Box, styled } from "@mui/material";

export const Container = styled(Box)`
  & .rct-node.GROUP .rct-title {
    font-weight: 500;
    color: ${({ theme }) => theme.palette.secondary.main};
  }

  & .rct-node.LAYER .rct-title {
    font-weight: 400;
    color: ${({ theme }) => theme.palette.text.primary};
  }
  & label {
    display: inline-flex;
    align-items: center;
  }
  & .rct-disabled {
    /* Hide checkboxes for disabled nodes (Groups and disabled Sublayers) */
    > .rct-text > label {
      flex-grow: 1;
      opacity: 1;
      cursor: default;
      > .rct-checkbox {
        display: none;
      }
    }
    /* We override the default disabled styles to keep the text fully opaque and the checkbox visible for disabled styles */
    .rct-checkbox.rct-checkbox {
      color: ${({ theme }) => theme.palette.primary.main};
      opacity: 1;
    }
  }
`;
